import { Environment, getEnvironment } from "utils/environment";

const SENTRY_ENABLED_ENVIRONMENTS = [Environment.PROD];

const isSentryEnabled = () =>
  SENTRY_ENABLED_ENVIRONMENTS.includes(getEnvironment());

export default isSentryEnabled;
